import { API_V4 } from "@/services/config/auth-axios";

class DirectDebit {
  getAllGateways() {
    return API_V4.get("/direct-payment/gateways");
  }

  getAllContracts() {
    return API_V4.get("/direct-payment/contracts");
  }
  getAllTransactionList() {
    return API_V4.get("/direct-payment/transactions");
  }
  pageInfo() {
    const lang = localStorage.getItem("lang");
    return API_V4.get(`/core/pages/direct-payment-page/${lang}`);
  }
  createContract(data) {
    return API_V4.post("/direct-payment/contracts/create", data);
  }

  createTransaction(data) {
    return API_V4.post("/direct-payment/transactions/create", data);
  }
  deleteContract(id) {
    return API_V4.post(
      `/direct-payment/contracts/${id}/delete`,
      {},
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  }
}

export default new DirectDebit();
